import {FC} from "react";
import styled from "styled-components/macro";
import {
  Card as MuiCard,
  useTheme,
} from "@material-ui/core";
import { Bar } from "react-chartjs-2";
const ChartWrapper = styled.div`
  height: 300px;
  width: 100%;
`;
type PropsType = {
  data: Array<number[]>,
  labels: Array<string>
}
const BarChart: FC<PropsType> = ({ data, labels }) => {
  const theme = useTheme()

  const getDatasets = () => {
    const datasets = [
      {
        label: "",
        backgroundColor: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
        hoverBackgroundColor: theme.palette.secondary.main,
        hoverBorderColor: theme.palette.secondary.main,
        data: [],
        barPercentage: 0.75,
        categoryPercentage: 0.5,
      },
      {
        label: "",
        backgroundColor: theme.palette.grey[300],
        borderColor: theme.palette.grey[300],
        hoverBackgroundColor: theme.palette.grey[300],
        hoverBorderColor: theme.palette.grey[300],
        data: [],
        barPercentage: 0.75,
        categoryPercentage: 0.5,
      },
    ]

    return datasets.map((dataset, index) => {
      return {...dataset, data: data[index] }
    })
  }

  const chartData = {
    labels: labels,
    datasets: getDatasets()
  };

  const chartOptions = {
    animation: {
      duration: 0
    },
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      yAxes: [
        {
          gridLines: {
            display: false,
          },
          stacked: false,
          ticks: {
            // stepSize: 20
          }
        },
      ],
      xAxes: [
        {
          stacked: false,
          gridLines: {
            color: "transparent",
          },
        },
      ],
    },
  };
  return (
    <ChartWrapper>
      <Bar data={chartData} options={chartOptions} />
    </ChartWrapper>
  );
};
export default BarChart;